import Vue from "vue";
import Router from "vue-router";
import HomePage from "@/views/HomeView.vue";
import NotFound from "@/views/NotFound.vue";
import About from "@/views/AboutUsView.vue";
import Services from "@/views/ServicesView.vue";
import ServicesDetails from "@/views/ServicesDetailedView.vue";
import Contact from "@/views/ContactFormView.vue";
import Blog from "@/views/BlogView.vue";
import News from "@/views/NewsView.vue";
import BlogDetails from "@/views/BlogDetailedView.vue";
import PrivacyPolicyUs from "@/views/PrivacyPolicyUs.vue";
import TermsAndConditions from "@/views/TermsAndConditions.vue";
import PagePrivacy from "@/views/PagePrivacy.vue";
import TermsAndConditionsUsa from "@/views/TermsAndConditionsUsa.vue";
import PrivacyPolicy from "@/views/PrivacyPolicy.vue";
import PartnerappUsa from "@/views/PartertermsUSA.vue";
import PartenerTermsIndia from "@/views/PartnerTermsIndia.vue";
import PartnerPrivacyUSA from "@/views/PartnerPrivacyUSA.vue";
import PartnerPrivacyIndia from "@/views/PartnerPrivacyIndia.vue";  
Vue.use(Router);

// Function to detect and store user location
async function detectAndStoreLocation() {
  try {
    const response = await fetch("https://ipapi.co/json/");
    const data = await response.json();
    const isUS = data.country_code === "US";
    localStorage.setItem("userCountry", data.country_code);
    localStorage.setItem("isUS", isUS);
    return isUS;
  } catch (error) {
    console.error("Error detecting location:", error);
    localStorage.setItem("userCountry", "IN");
    localStorage.setItem("isUS", false);
    return false;
  }
}

const router = new Router({
  mode: "history",
  routes: [
    // Default routes (non-US)
    {
      path: "/",
      name: "Home",
      component: HomePage,
    },
    {
      path: "/about",
      name: "About",
      component: About,
    },
    {
      path: "/services",
      name: "Services",
      component: Services,
    },

    {
      path: "/terms-and-conditions",
      name: "terms-and-conditions",
      component: TermsAndConditionsUsa,
    },
    {
      path: "/services/:serviceName",
      name: "ServicesDetails",
      component: ServicesDetails,
      props: true,
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
    },
    {
      path: "/news",
      name: "News",
      component: News,
    },

    // US routes (location-specific)
    {
      path: "/us",
      name: "HomeUS",
      component: HomePage,
      meta: { location: "us" },
    },
    {
      path: "/us/about",
      name: "AboutUS",
      component: About,
      meta: { location: "us" },
    },
    {
      path: "/us/services",
      name: "ServicesUS",
      component: Services,
      meta: { location: "us" },
    },
    {
      path: "/us/services/:serviceName",
      name: "ServicesDetailsUS",
      component: ServicesDetails,
      props: true,
      meta: { location: "us" },
    },
    {
      path: "/us/contact",
      name: "ContactUS",
      component: Contact,
      meta: { location: "us" },
    },
    {
      path: "/us/news",
      name: "NewsUS",
      component: News,
      meta: { location: "us" },
    },
    {
      path: "/privacy-policy-of-us",
      name: "privacy-policy-of-us",
      component: PrivacyPolicyUs,
    },

    {
      path: "/privacy-policy",
      name: "privacy-policy",
      component: PrivacyPolicy,
    },

    {
      path: "/terms-conditions",
      name: "terms-conditions",
      component: TermsAndConditions,
    },

    {
      path: "/service-provider-privacy-policy-usa",
      name: "PartnerPrivacyUSA",
      component: PartnerPrivacyUSA,
    },


    {
      path: "/service-provider-privacy-policy-ind",
      name: "PartnerPrivacyIndia",
      component: PartnerPrivacyIndia,
    },
    {
      path: "/blog",
      name: "Blog",
      component: Blog,
    },
    {
      path: "/blog/:blogTitle",
      name: "BlogDetails",
      component: BlogDetails,
      props: true,
    },

    {
      path: "/pages/page_privacy",
      name: "PagePrivacy",
      component: PagePrivacy,
    },

    {
      path: "/service-provider-terms-and-conditions-ind",
      name: "PartnerappIndia",
      component: PartenerTermsIndia,
    },

    {
      path: "/service-provider-terms-and-conditions",
      name: "PartnerappUsa",
      component: PartnerappUsa,
    },

    // Bangalore routes (if you want to keep this pattern)
    {
      path: "/bangalore",
      name: "HomeBangalore",
      component: HomePage,
      meta: { location: "bangalore" },
    },

    // 404 - must be last
    {
      path: "*",
      name: "NotFound",
      component: NotFound,
      meta: { hideLayout: true },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0, behavior: "smooth" };
  },
});

// Navigation guard to redirect US users
router.beforeEach(async (to, from, next) => {
  if (to.path === "/" && !sessionStorage.getItem("locationChecked")) {
    sessionStorage.setItem("locationChecked", "true");
    const inUSA = await detectAndStoreLocation();
    if (inUSA) {
      next("/us");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
